import { useFormContext } from 'react-hook-form';
import { TextArea } from '@/app/components/form/TextArea';
import type { CreateClientFormData, EditClientResponse } from '@/types/clientsApiTypes';
import { RELATED_DATA_KEYS, type RelatedDataKeys } from '../../hooks/useUpdateTravelPreferencesWithRelatedData/types';

interface PersonalInfoSectionProps {
  basePath: 'primary_passenger.preference_data' | `related_passengers.${number}.preference_data`;
  maxLength?: number;
  onUpdateTravelPreferencesWithRelatedData?: (
    fieldKey: RelatedDataKeys,
    fieldName: string,
    fieldValue: unknown,
    fullPath: string
  ) => Promise<EditClientResponse | undefined>;
}

export const PersonalInfoSection = ({
  basePath,
  maxLength = 200,
  onUpdateTravelPreferencesWithRelatedData,
}: PersonalInfoSectionProps) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<CreateClientFormData>();

  const informationValue = watch(`${basePath}.personal.information`) ?? '';

  return (
    <div className="mt-4">
      <TextArea
        {...register(`${basePath}.personal.information` as any, {
          onBlur: (e) => {
            onUpdateTravelPreferencesWithRelatedData?.(
              RELATED_DATA_KEYS.personal,
              'information',
              e.target.value,
              `${basePath}.personal.information`
            );
          },
        })}
        value={informationValue}
        disableResize
        placeholder="Please provide any personal information we should know about you or this traveler, such as phobias or anxieties. This is also an opportunity to share any mobility needs or disabilities we should be aware of."
        rows={4}
        maxLength={maxLength}
        errors={errors}
      />
    </div>
  );
};